import { render, staticRenderFns } from "./options-values.vue?vue&type=template&id=58da1b82&"
import script from "./options-values.vue?vue&type=script&lang=js&"
export * from "./options-values.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports